import { createQueryKeys } from '@lukemorales/query-key-factory';

export const agency = createQueryKeys('agency', {
  mine: null,
  adminList: (filters: Record<string, string>) => [filters],
  adminDetail: (agencyId: string) => [agencyId],
});
